import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useOrganizationStore } from './state/OrganizationContainer';

export function useCurrentOrgNavigation() {
    const navigate = useNavigate();
    const { organizationId } = useParams();

    useEffect(() => {
        const handlePermissionChangeRedirect = () => {
            const organizationStore = useOrganizationStore.getState();
            if (!organizationStore?.memberships || organizationStore.memberships?.length < 1) {
                navigate('/', { replace: true });
                return;
            }
            const currentMember = organizationStore.getOrganizationMembership(organizationId);
            if (!currentMember) {
                navigate('/', { replace: true });
            }
        };

        const handleOrgNullRedirect = () => {
            if (!organizationId) {
                navigate('/', { replace: true });
            }
        };

        handlePermissionChangeRedirect();
        handleOrgNullRedirect();
    }, [organizationId]);
}
